import { Component } from '@angular/core';
import { faCircle, faExclamation, IconDefinition } from '@fortawesome/pro-solid-svg-icons';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { ClientPhoneState } from 'src/app/store/samwin/client-phone/client-phone.state';
import { CallRecordingState } from 'src/generated/signalR/call-recording-state';

@Component({
   selector: 'samweb-recording',
   templateUrl: './recording.component.html',
   styleUrls: ['./recording.component.scss'],
})
export class RecordingComponent {
   @Select(ClientPhoneState.getRecordingState)
   public recordingState$: Observable<CallRecordingState>;

   public RECORDINGSTATEENUM = CallRecordingState;

   public recordingDot: IconDefinition = faCircle;
   public recordingExclamation: IconDefinition = faExclamation;

   constructor(private store: Store) {}
}
